export default __webpack_public_path__ + "static/LuciPavimenti-4e03360d0572f08f8d9edd83f85df41e.jpg";